import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue'
import getOfficesType from "@/types/responses/getOffices"
import FormRow from "@/components/Common/FormRow.vue"
import { computed } from "vue"
import i18n from '@/lang/i18n'

type modelValueType = {
  id: number | null,
  operation_office_id: number | null,
  name: string | null
}

type selectedOfficeType = {
  id: number | null
  type: string
  name: string | undefined
  departments: getOfficesType['departments']
}

type officeableType = {
  id: number | null,
  name: string | null,
  type: string | null
}

const OPERATION_OFFICE_TYPE = 'OperationOffice'


export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentColumn',
  props: {
    modelValue: {},
    selectedOffice: {},
    selectedOfficeableType: {},
    initialItemId: {},
    errors: {},
    isDepartment: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const isOperationOffice = computed(() => {
  return props.selectedOfficeableType.type === OPERATION_OFFICE_TYPE
})

const operationOffices = computed(() => {
  if (!isOperationOffice.value) {
    resetDepartment()
  }
  return props.selectedOffice?.type == OPERATION_OFFICE_TYPE ? [props.selectedOffice] : []
})

function resetDepartment() {
  modelValue.value = { id: null, operation_office_id: null, name: null }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormRow, {
    title: _unref(i18n).global.t('pages.common.autocomplete.department'),
    required: props.isDepartment
  }, {
    default: _withCtx(() => [
      _createVNode(DepartmentAutoComplete, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        operationOffices: operationOffices.value,
        readonly: !isOperationOffice.value,
        initialItemId: props.initialItemId,
        errorMessages: props.errors
      }, null, 8, ["modelValue", "operationOffices", "readonly", "initialItemId", "errorMessages"])
    ]),
    _: 1
  }, 8, ["title", "required"]))
}
}

})